import React, { useEffect } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchNeuroResult } from '../store/slices/neuroSlice';
import NeuroResultsPanel from '../components/neuro/NeuroResultsPanel';

const NeuroResultsPage = () => {
  const { evaluationId } = useParams();
  const dispatch = useDispatch();
  const { result, loading, error } = useSelector((state) => state.neuro);

  useEffect(() => {
    if (evaluationId) {
      dispatch(fetchNeuroResult(parseInt(evaluationId, 10)));
    }
  }, [dispatch, evaluationId]);

  if (loading && !result) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFF9F0' }}>
        <CircularProgress sx={{ color: '#784e3c' }} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4, backgroundColor: '#FFF9F0', minHeight: '100vh' }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#FFF9F0', px: 2, py: 4, maxWidth: 720, mx: 'auto' }}>
      <NeuroResultsPanel
        result={result}
        evaluationId={evaluationId}
        showTitle
        showHomeButton
        showEmailSend
      />
    </Box>
  );
};

export default NeuroResultsPage;
